import Cookies from 'js-cookie';
(function ($) {

    $(document).ready(function () {

        $('.alerte-banner__close').click(function () {
            let alerte = $(this).parents('.alerte-banner__item').attr('id');
            close_alerte(alerte);
        });
        $('.alerte-banner__item').each(function() {
            let id =  this.id ;
            if (!Cookies.get('#'+id)) {
                setTimeout(function () {
                    open_alerte(id);
                }, 500);
            }
        });

        function open_alerte (alerte_name) {
            let alerte = $('#'+alerte_name);
            alerte
                .css("display", "flex")
                .hide()
                .fadeIn();
        }

        function close_alerte (alerte_name) {
            let alerte = $('#'+alerte_name);
            alerte.fadeOut();
            Cookies.set('#'+alerte_name, true, { expires: 1, path: '/' });
        }
    });
})(jQuery);
